import angular from 'angular';

function counter() {
  return {
    restrict: 'A',
    templateUrl: 'common/directives/counter/counter.tpl.html',
    controllerAs: '$ctrl',
    controller: 'CounterController',
    bindToController: {
      text: '@',
      callback: '&refreshCallback',
    },
  };
}

CounterController.$inject = ['$q'];

/**
 * CounterController
 *
 * @class CounterController
 * @constructor
 * @param $q
 * @return {CounterController} - Class instance
 */
function CounterController($q) {
  Object.assign(this, {
    $q: $q,
  });
}

/**
 * Angular lifecycle method $onInit
 *
 * Initialise the View Model
 */
CounterController.prototype.$onInit = function () {
  this.vm = this._getVm(this);
};

/**
 * Angular lifecycle method $onChanges
 *
 * @param {Object.<any>} changes - Angular changesObj
 * @return {Undefined}
 */
CounterController.prototype.$onChanges = function (changes) {
  var update = { text: changes.text.currentValue }; // TODO Use Utils

  Object.assign(this, update);
  this.vm = this._getVm(this);
};

/**
 * Creates the View Model and
 * @param initialData
 * @returns {{text: string, isActive: boolean}}
 * @private
 */
CounterController.prototype._getVm = function (initialData) {
  var _data = initialData || {},
    text = _data.text || '',
    isActive = _data.isActive || false;

  return {
    text: text,
    isActive: isActive,
  };
};

/**
 * Refresh involves calling the provided promise-based callback
 * and setting state to show that the callback is in progress.
 */
CounterController.prototype.refresh = function () {
  if (typeof this.callback === 'function') {
    var self = this;
    self.vm.isActive = true;

    self.callback().then(
      function (response) {
        self.vm.isActive = false;
        return response;
      },
      function (response) {
        self.vm.isActive = false;
        return self.$q.reject(response);
      }
    );
  }
};

export const CounterDirectiveModule = angular
  .module('acme.common.directive.counter', [])
  .directive('counter', counter)
  .controller('CounterController', CounterController).name;
